var safeInit;

if (window.Tracking == null) {
  window.Tracking = {};
}

safeInit = function(obj, payload, cb) {
  var err;
  try {
    return obj.init(payload, cb);
  } catch (error) {
    err = error;
    OptimizeSuite.TrackingHub.add("DealPage-FrontEndInit-Error", {
      error: err
    });
    if (window.location.hostname === 'localhost' && (console.error != null)) {
      console.error(err);
    }
    return cb();
  }
};

Tracking.Initializer = function(timeoutInMs) {
  var finished, inFlight;
  if (timeoutInMs == null) {
    timeoutInMs = 30 * 1000;
  }
  inFlight = 0;
  this._hasRun = false;
  finished = false;
  return {
    run: function(modules, payload, cb) {
      var i, len, module;
      for (i = 0, len = modules.length; i < len; i++) {
        module = modules[i];
        inFlight++;
        safeInit(module, payload, (function(_this) {
          return function() {
            inFlight--;
            if (inFlight === 0 && _this._hasRun && !finished) {
              finished = true;
              return cb();
            }
          };
        })(this));
      }
      this._hasRun = true;
      if (inFlight === 0 && !finished) {
        finished = true;
        cb();
      }
      return setTimeout((function() {
        if (!finished) {
          OptimizeSuite.TrackingHub.add("DealPage-FrontEndInit-Timeout", {
            numberInFlight: inFlight
          });
          finished = true;
          if (window.location.hostname === 'localhost' && (console.error != null)) {
            console.error("Frontend Module Initialization timed out");
          }
          return cb();
        }
      }), timeoutInMs);
    }
  };
};

module.exports = Tracking.Initializer;

//# sourceMappingURL=data:application/json;base64,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
